import { CloseOutlined, DeleteOutlined } from '@ant-design/icons';
import { Col, Row, Typography } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import Hoverable from '../../../../components/Hoverable';
import { RemoveItemButton, SeparatorRight } from './style';

const { Text } = Typography;

export default function ListClientes({
  title,
  clientes,
  setClientes,
  atualizaPagadores,
}) {
  const handleRemoveItemCliente = index => {
    clientes.splice(index, 1);
    setClientes([...clientes]);
    atualizaPagadores();
  };

  if (!clientes.length) return <></>;

  return (
    <Row gutter={12}>
      <Col offset={2} className="padding-left-37">
        <Row gutter={[10, 14]} justify="space-between">
          <Typography.Text>{title}</Typography.Text>
        </Row>
        {clientes.map((item, index) => (
          <Row
            key={item.id}
            gutter={[1, 10]}
            justify="space-between"
            align="middle"
          >
            <Col>
              <Row gutter={[1, 10]} justify="start" align="middle">
                <SeparatorRight>
                  <RemoveItemButton
                    aria-label="removeButton"
                    type="link"
                    block
                    onClick={() => handleRemoveItemCliente(index)}
                  >
                    <Hoverable
                      render={hovered => {
                        if (hovered) {
                          return (
                            <DeleteOutlined style={{ color: '#ff0000' }} />
                          );
                        }
                        return <CloseOutlined />;
                      }}
                    />
                  </RemoveItemButton>
                </SeparatorRight>
                <Col>
                  <Row>
                    <Text>{`CNPJ: ${item.cnpj ?? item.cnpj_resumido}`}</Text>
                  </Row>
                  <Row>
                    <Text>{`Razão social: ${item.razao_social.toUpperCase()}`}</Text>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        ))}
      </Col>
    </Row>
  );
}

ListClientes.propTypes = {
  title: PropTypes.string.isRequired,
  clientes: PropTypes.arrayOf(
    PropTypes.shape({
      cnpj: PropTypes.string,
      razao_social: PropTypes.string,
    })
  ).isRequired,
  setClientes: PropTypes.func.isRequired,
  atualizaPagadores: PropTypes.func,
};

ListClientes.defaultProps = {
  atualizaPagadores: () => {},
};
